import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button
} from "@mui/material"
import { Checkbox } from 'antd'

const PrepareForFirstSupervisionStage = ({ rowData, mainProps, setErrorMessage }) => {



  return (
    <Box>
      <Checkbox
        disabled={rowData.row.projectLevelEnum !== 1 || rowData.row.isPrepareForFirstSupervisionStage || rowData.row.isCancel }
        checked={ rowData.row.isPrepareForFirstSupervisionStage}
        onChange={async () => {
            const { onPrepareForFirstSupervisionStage } = mainProps
            if(window.confirm("در صورت تایید واحد گاز مرحله نظارت اولیه را تخصیص میدهد")){
                await onPrepareForFirstSupervisionStage({gpId:rowData.row.id, prepare:!rowData.row.isPrepareForFirstSupervisionStage})
            }
           
        }}
      >
      </Checkbox>

    </Box>
  )
}

export default PrepareForFirstSupervisionStage
